import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MailRecordEntity } from './mail-record.entity';

@Index('_unique_attachment', ['fkMailRecordId', 'externalAttachmentId'], {
	unique: true,
})
@Entity('_mail_attachment')
export class MailAttachmentEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__mail_record__id',
		nullable: true,
		unsigned: true,
	})
	public fkMailRecordId!: number | null;

	@Column('varchar', { name: '_externalAttachmentId', length: 191 })
	public externalAttachmentId!: string;

	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('varchar', { name: '_mimeType', length: 150 })
	public mimeType!: string;

	@ManyToOne(
		() => MailRecordEntity,
		(mailRecord) => mailRecord.mailAttachments,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__mail_record__id', referencedColumnName: 'id' }])
	public fkMailRecord!: MailRecordEntity;
}
